module.exports = __webpack_public_path__ + "static/media/check.304dc006.svg";